import { Download } from "lucide-react";
import { motion } from "framer-motion";

export default function Brochure() {
  const styles = {
  
    banner: {
      width: "60%",
      borderRadius: "20px",
      background: "linear-gradient(90deg, #004270, #4338ca)",
      padding: "10px 20px",
      boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
   
     
    },
    text: {
      color: "#ffffff",
      fontSize: "18px",
      fontWeight: 600,
      textAlign: "center",
    },
    button: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      fontSize: "16px",
      padding: "14px 24px",
      borderRadius: "16px",
      background: "#ffffff",
      color: "#004270",
      border: "none",
      cursor: "pointer",
      boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
      fontWeight: 500,
    },
  };

  return (

    <div className="layout8"> 
    <div style={styles.container} >
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        style={styles.banner}
      >
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
          style={styles.text}
        >
          Descarga nuestro brochure informativo
        </motion.p>

        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          style={styles.button}
        >
          <motion.span
            animate={{ y: [0, -4, 0] }}
            transition={{ repeat: Infinity, duration: 1.2 }}
          >
            <Download size={20} />
          </motion.span>
          Descargar
        </motion.button>
      </motion.div>
    </div></div>
  );
}
